import { makeStyles } from '@material-ui/core'

export default makeStyles((theme) => ({
  dialog: {
    padding: 24
  },
  searchInput: {
    width: '100%',
    marginBottom: 12
  },
  buttons: {
    marginTop: theme.spacing(2)
  }
}))
